import React from 'react'

const Manual_crear_producto_dashboard_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          ¿Cómo crear un producto desde el Dashboard de Clau.io?
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a crear nuevos productos desde el panel administrativo de Clau.io para mantener tu catálogo actualizado.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_crear_un_producto_desde_el_Dashboard_de_Clauio__VO0LYSoLSG-w0qMGkCn5VQ?as=scrollable"
          className="scribe-iframe-general-130"
          width="100%"
          height="6600"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_crear_producto_dashboard_clau
